export default {
  on: {
    pageInit: function (e) {
      var items = [];
      for (var i = 1; i <= 100; i++) {
        items.push({
          title: 'Item ' + i,
          subtitle: i % 5 ? '通常アイテム' : 'ビッグアイテム',
          classname: i % 5 ? '' : 'big-li'
        });
      }
      window.virtualList = app.virtualList.create({
        el: '.virtual-list',
        items: items,
        renderItem: function (item) {
          var html = '<li class="' + item.classname + '">' + '  <a href="#" class="item-link item-content">' + '    <div class="item-inner">' + '    <div class="item-title-row">' + '    <div class="item-title">' + item.title + '</div>' + '    </div>' + '    <div class="item-subtitle">' + item.subtitle + '</div>' + '    </div>' + '  </a>' + '</li>';
          return html;
        },
        height: function (item) {
          if (item.classname == 'big-li') {
            return 128;
          } else {
            return 64;
          }
        },
        on: {
          itemsBeforeInsert: (virtualList, fragment) => {
            if (virtualList.reachEnd) {
              setTimeout(function () {
                var items = [];
                for (var i = virtualList.items.length + 1; i <= virtualList.items.length + 20; i++) {
                  items.push({
                    title: 'Item ' + i,
                    subtitle: i % 5 ? '通常アイテム' : 'ビッグアイテム',
                    classname: i % 5 ? '' : 'big-li'
                  });
                }
                virtualList.appendItems(items);
              }, 100);
            }
          }
        }
      });
    }
  },
  id: '9f2b7dff1e',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page" data-name="home">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="title sliding">バーチャルリスト</div>\n      </div>\n    </div>\n\n    <div class="page-content">\n      <!-- バーチャルリスト -->\n      <div class="list virtual-list media-list">\n        <!-- 初期は空のままにしておく -->\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};